import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import NavigationWrapper from '../../components/sessionNavigation/navigationWrapper';
import PopoverSelector from '../../components/popoverSelector/popoverSelector';
import { useTranslation } from 'react-i18next';
import CenteredToast from '../../components/centeredToast/centeredToast';
import { useNavigationManager } from '../../logic/nextNav';
const WellfitSelection = () => {
  const { t } = useTranslation("translation", { keyPrefix: "wellfitSelection" });
  const tanProfile = useSelector((state) => state?.tanProfile)
  // const [navigate, setNavigate] = useState()
  const { currentIndex, prevIndex, navigate, sessionSelection } = useNavigationManager();
  const [alert, setAlert] = useState()
  const validate = () => {
    let items = tanProfile?.selectedProfile?.session_component.filter((item) => item.component_id === 22) //don't @ me
    if (items.length < 1) {
      setAlert({
        onHide: () => { setAlert(null) },
        title: t("valid.title", "Missing wellfit"),
        body: t("valid.body", "You need to select wellfit for a wellfit or Tan + wellfit session!"),
      })
    } else {
      navigate(true)
    }
  }
  return (
    <>
      <NavigationWrapper preventProceed={true} onNext={() => { validate() }}>
        <div className='session-header'>
          {t("title", "CHOOSE YOUR WELLFIT™ SKINCARE TREATMENT")}

        </div>

        <PopoverSelector itemtype={"wellfit"} amount={2} />
        {alert && <CenteredToast
        show={alert}
          onHide={alert.onHide}
          title={alert.title}
          body={alert.body}
          hideCancelButton={true}
        >
        </CenteredToast>}
      </NavigationWrapper >
    </>
  );
};

export default WellfitSelection;

